
export default {
  // Reviews
  "edit_review": "Editar Avaliação",
  "review": "Avaliação",
  "film_friendly_score": "Pontuação de Amigabilidade ao Filme",
  "hand_check": "Verificação Manual",
  "successful": "Bem-sucedido",
  "unsuccessful": "Malsucedido",
  "delete_review": "Excluir Avaliação",
  "review_by": "Avaliação por",
};
